import type { Messages } from "./en";

export const ar: Messages = {
  brandShort: "دار النعيم",
  brandOrg: "مجمع دار النعيم للعلوم الشرعية بنيجيريا",
  conferenceEdition: "المؤتمر الدولي السنوي الثامن عشر",
  nav: {
    home: "الرئيسية",
    cfp: "دعوة للمشاركة",
    schedule: "البرنامج",
    venue: "المكان",
    papers: "الأوراق العلمية",
    pastEvents: "الفعاليات السابقة",
    register: "التسجيل",
    login: "تسجيل الدخول",
    dashboard: "لوحتي",
    myPapers: "أوراقي",
    submit: "تقديم ورقة",
    reviews: "المراجعات",
    admin: "الإدارة",
    adminWorkspace: "مساحة الإدارة",
    participantWorkspace: "مساحة المشارك",
    adminOverview: "نظرة عامة",
    adminRegistrations: "التسجيلات",
    adminReviewers: "المراجعون",
    adminPapers: "الأوراق",
    adminPastEvents: "الفعاليات السابقة",
    adminSessions: "الجلسات",
    adminCorrespondence: "المراسلات",
    adminMessages: "الرسائل",
    adminCertificates: "الشهادات",
    adminReminders: "رسائل التذكير",
    adminSettings: "إعدادات المؤتمر",
    viewPublicSite: "عرض الموقع العام",
    accountSecurity: "الحساب / الأمان",
    logout: "خروج",
    language: "اللغة",
    langEn: "EN",
    langAr: "العربية",
    langFr: "FR",
  },
  pastEvents: {
    title: "الفعاليات السابقة",
    lead: "تصفّح منشورات المجمع والمواد المؤرشفة للفعاليات السابقة.",
    year: "السنة",
    view: "عرض",
    downloadPdf: "تنزيل PDF",
    openPdf: "فتح PDF",
    openFullscreen: "فتح PDF في تبويب جديد",
    pdfUnavailable: "ملف PDF غير متاح بعد",
    backToArchive: "العودة إلى الفعاليات السابقة",
    emptyTitle: "لا توجد فعاليات منشورة بعد",
    emptyBody: "ستظهر هنا العناصر المنشورة في الأرشيف.",
  },
  hero: {
    ctaRegister: "سجّل في المؤتمر",
    ctaSubmit: "قدّم ورقة بحثية",
    countdown: "العدّ التنازلي لبدء المؤتمر",
    days: "أيام",
    hours: "ساعات",
    minutes: "دقائق",
    seconds: "ثوانٍ",
  },
  sections: {
    about: "عن المؤتمر",
    aboutBody:
      "ملتقى علمي دولي ينظمه مجمع دار النعيم للعلوم الشرعية بنيجيريا لاستكشاف فقه التعامل مع الآخرين على ضوء الشريعة.",
    theme: "محور المؤتمر",
    dates: "مواعيد مهمة",
    abstractDeadline: "آخر موعد لملخصات الأبحاث",
    paperDeadline: "آخر موعد للأوراق الكاملة",
    conferenceDates: "المؤتمر الدولي",
    nationalOptional: "المؤتمر الوطني (اختياري / تمهيدي)",
    cfp: "دعوة للمشاركة بأوراق بحثية",
    cfpBody: "ندعو الباحثين لتقديم الملخصات والأوراق بالعربية أو الإنجليزية أو الفرنسية.",
    topics: "محاور مقترحة",
    guidelines: "ضوابط التقديم",
    programme: "برنامج المؤتمر",
    live: "البث المباشر",
    papersArchive: "الأوراق العلمية / أرشيف المؤتمرات",
    papersArchiveBody:
      "تصفّح الأوراق العلمية عبر دورات مؤتمر دار النعيم، بما في ذلك عيّنات مفتوحة الوصول موثّقة.",
    browseAllPapers: "تصفّح كل الأوراق",
    submittedPapers: "الأوراق العلمية / أرشيف المؤتمرات",
    submittedPapersBody:
      "تصفّح الأوراق العلمية عبر دورات مؤتمر دار النعيم، بما في ذلك عيّنات مفتوحة الوصول موثّقة.",
    viewAllPapers: "تصفّح كل الأوراق",
    venue: "المكان والتواصل",
    organizer: "الجهة المنظمة",
    director: "المدير العام",
    contact: "التواصل",
    finalCta: "انضم إلى المؤتمر",
    finalCtaBody: "سجّل الآن وقدّم ورقتك. تُسلَّم البطاقات المادية في الموقع.",
  },
  guidelines: {
    languages: "اللغات المقبولة: العربية والإنجليزية والفرنسية",
    arabicFont: "العربية: Traditional Arabic بحجم 18",
    englishFont: "الإنجليزية: Times New Roman بحجم 12",
    frenchFont: "الفرنسية: Times New Roman بحجم 12",
    format: "التقديم بصيغة Microsoft Word (.doc / .docx)",
  },
  register: {
    title: "التسجيل في المؤتمر",
    subtitle: "أنشئ حساب المشارك واستلم تأكيد التسجيل.",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    confirm: "تأكيد كلمة المرور",
    fullName: "الاسم الكامل",
    fullNameAr: "الاسم بالعربية (اختياري)",
    phone: "الهاتف / واتساب",
    country: "الدولة",
    city: "المدينة (اختياري)",
    institution: "المؤسسة / الانتماء",
    role: "اللقب الأكاديمي / المهني",
    preferredLang: "اللغة المفضلة",
    organization: "المنظمة (اختياري)",
    notes: "ملاحظات (اختياري)",
    passiCode: "رمز استرجاع Passi",
    passiCreateLink: "افتح Passi",
    passiInstructionsTitle: "كيف أحصل على رمز استرجاع Passi؟",
    passiSummarySteps:
      "١. افتح Passi وانقر Start creating\n٢. اختر Generic portrait (1200×1200 square)\n٣. ارفع صورة أو استخدم الكاميرا\n٤. أكّد الصورة وعدّل/قص ثم أكمل Final checks\n٥. انقر Stage and generate retrieval code ثم Confirm and upload\n٦. انسخ رمز الاسترجاع المكوّن من 6 أحرف (وليس delete secret)\n٧. ارجع هنا والصقه في هذا الحقل",
    passiOptionalNote: "الصورة اختيارية. يمكنك إتمام التسجيل بدون رمز استرجاع Passi.",
    passiOpenGuide: "افتح الدليل المرئي خطوة بخطوة",
    passiGuideOpensNewTab: "يُفتح في تبويب جديد حتى لا تفقد بيانات نموذج التسجيل.",
    submit: "إتمام التسجيل",
    success: "تم التسجيل بنجاح",
    successBody:
      "تم إكمال تسجيلك بنجاح. تم إرسال رسالة تأكيد إلى بريدك الإلكتروني. يُرجى ملاحظة أن وصول الرسالة قد يستغرق بضع دقائق. إذا لم تظهر في صندوق الوارد، فتحقق أيضًا من مجلد الرسائل غير المرغوب فيها (Spam/Junk).",
    code: "رمز التسجيل",
    cardAtVenueNote: "ستُسلَّم بطاقتك المادية عند وصولك إلى المؤتمر.",
    goDashboard: "الذهاب إلى لوحتي",
  },
  passiGuide: {
    eyebrow: "مساعدة الصورة",
    title: "دليل Passi المرئي خطوة بخطوة",
    intro:
      "اتبع هذه اللقطات لإنشاء صورة المؤتمر في Passi ونسخ رمز استرجاع مكوّن من 6 أحرف لتسجيل دار النعيم.",
    optionalNote: "إضافة صورة اختيارية. يمكنك التسجيل في المؤتمر بدون رمز استرجاع Passi.",
    openPassi: "افتح Passi",
    returnRegister: "العودة إلى التسجيل",
    copyCodeNotSecret:
      "مهم: انسخ رمز الاسترجاع المكوّن من 6 أحرف فقط — وليس delete secret الأطول.",
    step1Title: "افتح Passi وابدأ",
    step1Body: "اذهب إلى passi.fingletek.com وانقر الزر الأخضر Start creating.",
    step1Callout: "انقر Start creating",
    step2Title: "أنت في Create photo",
    step2Body: "يفتح Passi قائمة القوالب. بعد ذلك ستختار صورة مؤتمر عامة.",
    step3Title: "اختر Generic portrait (1200×1200 square)",
    step3Body:
      "ابحث عن البطاقة Generic portrait (1200×1200 square) وانقر Select this template. لا تختر قالب جواز/تأشيرة.",
    step3Callout: "Select this template",
    step4Title: "ارفع صورة أو استخدم الكاميرا",
    step4Body: "اختر Upload photo لاختيار ملف من جهازك، أو Use camera capture لالتقاط صورة جديدة.",
    step4Callout: "Upload photo أو Use camera",
    step5Title: "أكّد صورتك",
    step5Body: "راجع المعاينة ثم أكّد/تابع حتى ينتقل Passi إلى القص والتحرير.",
    step5Callout: "Confirm / continue",
    step6Title: "عدّل واقصّ الصورة",
    step6Body: "اسحب لتوسيط الوجه وكبّر إن لزم ثم تابع إلى Final checks.",
    step6Callout: "Continue بعد القص",
    step7Title: "راجع Final checks",
    step7Body: "اقرأ الفحوصات التلقائية. التحذيرات مقبولة لصورة المؤتمر — تابع إلى التخزين المرحلي.",
    step8Title: "Stage and generate retrieval code",
    step8Body: "مرّر إلى Stage for retrieval وانقر Stage and generate retrieval code.",
    step8Callout: "Stage and generate retrieval code",
    step9Title: "أكّد الرفع",
    step9Body: "يطلب Passi تأكيد التخزين المرحلي. انقر Confirm and upload.",
    step9Callout: "Confirm and upload",
    step10Title: "اعثر على رمز الاسترجاع المكوّن من 6 أحرف",
    step10Body: "يظهر رمز الاسترجاع القصير تحت Stage for retrieval. هذا ما تحتاجه دار النعيم.",
    step10Callout: "رمز الاسترجاع (6 أحرف)",
    step11Title: "انسخ رمز الاسترجاع",
    step11Body: "انقر Copy بجانب رمز الاسترجاع. لا تنسخ delete secret أسفله.",
    step11Callout: "Copy رمز الاسترجاع",
    step12Title: "ارجع إلى تسجيل دار النعيم",
    step12Body:
      "عد إلى تبويب التسجيل، الصق الرمز في حقل رمز استرجاع Passi، وأكمل التسجيل. يفترض أن تبقى حقول النموذج كما هي.",
  },
  login: {
    title: "دخول المشارك / الإدارة",
    submit: "دخول",
    noAccount: "ليس لديك حساب؟",
  },
  setPassword: {
    title: "تعيين كلمة المرور",
    lead: "حسابك يستخدم كلمة مرور مؤقتة. اختر كلمة مرور جديدة قبل المتابعة.",
    currentPassword: "كلمة المرور الحالية (المؤقتة)",
    newPassword: "كلمة المرور الجديدة",
    confirmPassword: "تأكيد كلمة المرور الجديدة",
    submit: "حفظ كلمة المرور",
  },
  accountSecurity: {
    title: "الحساب / الأمان",
    lead: "غيّر كلمة مرور حساب المؤتمر. ستبقى مسجّل الدخول على هذا الجهاز.",
    currentPassword: "كلمة المرور الحالية",
    newPassword: "كلمة المرور الجديدة",
    confirmPassword: "تأكيد كلمة المرور الجديدة",
    policyHint: "استخدم 8 أحرف على الأقل. لا تُعِد استخدام كلمة المرور الحالية.",
    submit: "تحديث كلمة المرور",
    success: "تم تحديث كلمة المرور بنجاح.",
    mismatch: "كلمة المرور الجديدة وتأكيدها غير متطابقين.",
  },
  dashboard: {
    title: "لوحة المشارك",
    registration: "تسجيل المؤتمر",
    registered: "مسجّل",
    badge: "شارتي",
    cardAtVenue: "بطاقة المؤتمر",
    cardAtVenueHelp: "تُسلَّم البطاقات المادية عند تسجيل الحضور. لا يتوفر تنزيل رقمي.",
    papers: "أوراقي",
    schedule: "برنامج المؤتمر",
    liveNow: "يبث الآن",
    profile: "الملف الشخصي",
    noPapers: "لا توجد أوراق بعد",
    submitPaper: "تقديم ورقة",
    reviews: "مراجعات",
    reviewsHelp: "الأوراق المعيَّنة لك لمراجعة النظراء في المؤتمر.",
    openReviews: "فتح المراجعات",
    editorialDecision: "القرار التحريري",
    submitRevisedPaper: "تقديم الورقة المنقّحة",
    submitRevision: "إرسال المراجعة",
    revisionFile: "المخطوط المنقّح (.doc / .docx)",
    revisionNotes: "الرد على القرار / ملاحظات المراجعة",
    revisionNotesHelp: "رد مختصر اختياري على القرار التحريري.",
    revisionNeedFile: "اختر ملفًا بصيغة .doc أو .docx.",
    revisionSubmitted: "تم تقديم المراجعة {n}. تم إشعار المنظمين.",
    revisionLabel: "مراجعة {n}",
  },
  reviews: {
    title: "مراجعات",
    lead: "الأوراق المعيَّنة لك كمراجع مؤتمر معيَّن.",
    empty: "لا توجد أوراق معيَّنة للمراجعة بعد.",
    colTitle: "العنوان",
    colAuthors: "المؤلفون",
    colLanguage: "اللغة",
    colAssigned: "تاريخ التعيين",
    colDue: "الاستحقاق",
    colStatus: "الحالة",
    statusAssigned: "معيَّنة",
    statusCompleted: "مكتملة",
    openReview: "فتح المراجعة",
    viewReview: "عرض المراجعة",
    reviewTitle: "مراجعة الورقة",
    downloadManuscript: "تنزيل المخطوط",
    noManuscript: "لا يوجد مخطوط",
    formTitle: "مراجعتك",
    comments: "تعليقات المراجعة",
    recommendation: "التوصية",
    recommendationPlaceholder: "اختر توصية",
    recAccept: "قبول",
    recMinor: "تعديل طفيف",
    recMajor: "تعديل جوهري",
    recReject: "رفض",
    saveDraft: "حفظ المسودة",
    submitFinal: "إرسال المراجعة النهائية",
    draftSaved: "تم حفظ المسودة",
    submitted: "تم إرسال المراجعة",
    submitNeedFields: "التعليقات والتوصية مطلوبان للإرسال.",
    readOnlyHelp: "تم إرسال هذه المراجعة وهي للقراءة فقط ما لم يعد فتحها المسؤول.",
    submittedAt: "تاريخ الإرسال",
  },
  paper: {
    title: "تقديم ورقة بحثية",
    paperTitle: "عنوان الورقة",
    titleAlt: "عنوان بديل (اختياري)",
    language: "اللغة",
    abstract: "الملخص",
    keywords: "الكلمات المفتاحية",
    authors: "المؤلفون",
    affiliation: "الانتماء",
    file: "ملف الورقة (.doc / .docx)",
    notes: "ملاحظات للمنظمين (اختياري)",
    submit: "إرسال الورقة",
    success: "تم إرسال الورقة بنجاح",
  },
  schedule: {
    title: "برنامج المؤتمر",
    preliminary: "",
    watchLive: "شاهد البث",
    liveNow: "مباشر الآن",
    ended: "انتهت الجلسة",
    upcoming: "سيتاح البث عند بدء الجلسة",
    demoTitle: "معاينة بث تجريبي",
    demoBody: "هذه معاينة توضيحية — وليست بثاً حياً فعلياً.",
    liveStreamTitle: "البث المباشر",
  },
  papers: {
    title: "الأوراق العلمية",
    lead: "ابحث في أرشيف الأوراق العلمية عبر جميع دورات المؤتمر الدولي السنوي لدار النعيم.",
    archiveSummary: "الأوراق العلمية — {conferences} مؤتمرات",
    filteredSummary: "{papers} ورقة عبر {conferences} مؤتمرات",
    search: "بحث في الأوراق",
    searchPlaceholder: "ابحث في العنوان، المؤلفين، الانتماء، الكلمات المفتاحية، الملخص…",
    clear: "مسح",
    filterLanguage: "اللغة",
    filterConference: "المؤتمر",
    conferenceAll: "كل المؤتمرات",
    conferenceSelected: "{count} مؤتمرات محددة",
    conferenceSearch: "ابحث في المؤتمرات…",
    clearConferences: "مسح اختيار المؤتمرات",
    langAll: "كل اللغات",
    langEnglish: "الإنجليزية",
    langArabic: "العربية",
    langFrench: "الفرنسية",
    results: "{count} ورقة",
    emptyTitle: "لا توجد أوراق",
    emptyBody: "جرّب بحثاً مختلفاً أو امسح فلاتر المؤتمر.",
    authors: "المؤلفون",
    affiliation: "الانتماء",
    keywords: "الكلمات المفتاحية",
    externalArchive: "أرشيف مفتوح الوصول / عيّنة",
    readOnline: "قراءة عبر الإنترنت",
    downloadPdf: "تنزيل PDF",
    pdfUnavailable: "ملف PDF غير متاح بعد",
    backToPapers: "العودة إلى الأوراق",
    prev: "السابق",
    next: "التالي",
    page: "صفحة {page} من {pages}",
  },
  status: {
    submitted: "مقدَّمة",
    under_review: "قيد المراجعة",
    minor_revision: "تعديل طفيف",
    major_revision: "تعديل جوهري",
    revised: "منقّحة",
    accepted: "مقبولة",
    rejected: "مرفوضة",
    published: "منشورة",
    publishedAccepted: "منشورة-مقبولة",
  },
  venue: {
    title: "المكان والتواصل",
    address: "العنوان",
    map: "فتح في الخرائط",
    mapTitle: "خريطة مكان المؤتمر",
    mapLoading: "جارٍ تحميل الخريطة…",
  },
  verify: {
    title: "التحقق من التسجيل",
    valid: "تسجيل صالح",
    invalid: "لم يُعثر على التسجيل",
  },
  admin: {
    title: "إدارة المؤتمر",
    statsRegs: "إجمالي التسجيلات",
    statsPapers: "الأوراق المقدّمة",
    statsAccepted: "الأوراق المقبولة",
    statsUpcoming: "الجلسات القادمة",
    statsCheckedIn: "تم تسجيل الحضور",
    registrations: "التسجيلات",
    papers: "الأوراق",
    papersLead: "مراجعة → قبول/رفض → تجهيز ونشر لإصدار PDF بعلامة المؤتمر إلى أرشيف الأوراق العامة.",
    pastEvents: "الفعاليات السابقة",
    pastEventsLead: "إضافة وتحرير ونشر أو أرشفة ملفات PDF للفعاليات السابقة في الأرشيف العام.",
    pastEventsAdd: "إضافة فعالية سابقة",
    pastEventsEdit: "تحرير فعالية سابقة",
    pastEventsSlug: "المعرّف المختصر",
    pastEventsYear: "السنة",
    pastEventsDate: "تاريخ الفعالية (اختياري)",
    pastEventsOrder: "ترتيب العرض",
    pastEventsTitleEn: "العنوان (الإنجليزية)",
    pastEventsTitleAr: "العنوان (العربية)",
    pastEventsTitleFr: "العنوان (الفرنسية)",
    pastEventsDescEn: "الوصف (الإنجليزية)",
    pastEventsDescAr: "الوصف (العربية)",
    pastEventsDescFr: "الوصف (الفرنسية)",
    pastEventsPdf: "ملف PDF",
    pastEventsPublished: "منشور",
    pastEventsArchived: "مؤرشف",
    pastEventsPublish: "نشر",
    pastEventsUnpublish: "إلغاء النشر",
    pastEventsCreated: "تم إنشاء الفعالية السابقة",
    pastEventsSaved: "تم حفظ الفعالية السابقة",
    pastEventsDeleteConfirm: "حذف سجل هذه الفعالية السابقة؟",
    sessions: "الجلسات",
    settings: "إعدادات المؤتمر",
    reminders: "رسائل التذكير",
    remindersLead:
      "تُرسل تذكيرات المشاركين تلقائيًا وفق تاريخ بدء المؤتمر (توقيت Lagos): أسبوعيًا قبل شهرين، مرتين أسبوعيًا في الشهر الأخير حتى 10 أيام، ثم يوميًا حتى بداية الحدث.",
    remindersEnabled: "التذكيرات مفعّلة",
    remindersOn: "تشغيل",
    remindersOff: "إيقاف",
    remindersEnable: "تفعيل التذكيرات",
    remindersDisable: "إيقاف التذكيرات",
    remindersNext: "التذكير المجدول التالي",
    remindersNone: "لا يوجد",
    remindersTimezone: "المنطقة الزمنية",
    remindersTotals: "إجمالي التسليم",
    remindersSent: "مُرسل",
    remindersFailed: "فشل",
    remindersEligible: "المستلمون المؤهلون",
    remindersRunNow: "معالجة التذكيرات المستحقة الآن",
    remindersRunDone: "اكتملت معالجة التذكيرات",
    remindersTest: "إرسال تذكير تجريبي",
    remindersTestHelp: "يُرسل فقط إلى البريد الذي تدخله — وليس إلى قائمة المشاركين كاملة.",
    remindersTestEmail: "بريد تجريبي مضبوط",
    remindersSendTest: "إرسال تجريبي",
    remindersTestSent: "تم إرسال/تسجيل التذكير التجريبي",
    remindersRecent: "أحدث الإرسالات / الإخفاقات",
    remindersWindow: "النافذة / الفترة",
    remindersScheduled: "التاريخ المجدول",
    remindersSentAt: "وقت الإرسال",
    printSelected: "تنزيل البطاقات المحددة",
    actions: "إجراءات",
    sendHotelReservation: "إرسال حجز الفندق",
    searchRegistrations: "بحث بالاسم أو البريد أو الهاتف أو المؤسسة أو الدولة أو الرمز…",
    cardType: "نوع البطاقة",
    cardTypeParticipant: "مشارك (B)",
    cardTypeHotel: "مشارك + فندق (C)",
    previewCard: "معاينة البطاقة",
    printDownloadCard: "طباعة / تنزيل البطاقة (PDF)",
    downloadCardPng: "تنزيل صورة البطاقة (PNG)",
    resendRegistration: "إعادة إرسال بريد التسجيل",
    makeReviewer: "تعيين كمراجع",
    removeReviewer: "إزالة صلاحية المراجع",
    reviewerBadge: "مراجع",
    reviewers: "المراجعون",
    reviewersLead:
      "المشاركون المسجّلون والمراجعون الخارجيون المعيّنون لمراجعة أوراق المؤتمر. إزالة صلاحية المراجع لا تحذف التسجيل.",
    addReviewer: "إضافة مراجع",
    addReviewerTitle: "إضافة مراجع خارجي",
    addReviewerLead: "ينشئ حساب مراجع ويرسل بريد دعوة (لا تُعرض كلمة المرور المؤقتة هنا).",
    addReviewerFullName: "الاسم الكامل",
    addReviewerEmail: "البريد الإلكتروني",
    addReviewerInstitution: "المؤسسة",
    addReviewerPhone: "الهاتف",
    addReviewerCountry: "البلد",
    addReviewerTitleRole: "اللقب الأكاديمي / المنصب",
    addReviewerExpertise: "مجالات الخبرة / الكلمات المفتاحية",
    addReviewerLanguage: "لغة البريد المفضّلة",
    addReviewerSubmit: "إنشاء المراجع",
    reviewerKind: "النوع",
    reviewerKindRegistered: "مشارك مسجّل",
    reviewerKindExternal: "مراجع خارجي",
    resendTempPassword: "إعادة إرسال / إنشاء كلمة مرور مؤقتة جديدة",
    resendTempPasswordDone: "تم إرسال كلمة مرور مؤقتة جديدة إلى المراجع بالبريد.",
    searchReviewers: "ابحث بالاسم أو البريد أو المؤسسة أو الرمز…",
    reviewersIncludeInactive: "تضمين غير النشطين",
    reviewersEmpty: "لا يوجد مراجعون معيّنون بعد.",
    reviewerName: "الاسم",
    reviewerInstitution: "المؤسسة",
    reviewerCode: "رمز التسجيل",
    reviewerAssignedAt: "تاريخ التعيين",
    reviewerStatus: "الحالة",
    reviewerActive: "نشط",
    reviewerInactive: "غير نشط",
    assignPapers: "تعيين أوراق",
    assignPapersTitle: "تعيين أوراق للمراجع",
    assignPapersLead: "ابحث في الأوراق المقدَّمة وعيّن ورقة أو أكثر لهذا المراجع المعيَّن. إلغاء التعيين لا يحذف الورقة ولا المراجع.",
    assignPapersInactiveBlocked: "هذا المراجع غير نشط ولا يمكنه استلام تعيينات جديدة.",
    assignPapersNeedSelection: "حدّد ورقة واحدة على الأقل للتعيين.",
    assignPapersDone: "تم تعيين الأوراق",
    assignmentCancelled: "تم إلغاء التعيين",
    currentAssignments: "التعيينات الحالية",
    noAssignments: "لا توجد تعيينات نشطة بعد.",
    cancelledAssignmentsCount: "{n} تعيين/تعيينات ملغاة محفوظة للتاريخ.",
    availablePapers: "الأوراق المتاحة",
    assignSearchPapers: "ابحث في العنوان أو المؤلفين أو الكلمات المفتاحية…",
    assignFilterLanguage: "اللغة",
    filterAllLanguages: "كل اللغات",
    assignFilterEdition: "رقم الدورة",
    assignFilterKeywords: "الكلمات المفتاحية",
    assignDueDate: "تاريخ الاستحقاق (اختياري)",
    assignSelectedPapers: "تعيين الأوراق المحددة",
    noAssignablePapers: "لا توجد أوراق مطابقة للتعيين.",
    cancelAssignment: "إلغاء التعيين",
    assignColTitle: "العنوان",
    assignColAuthors: "المؤلفون",
    assignColLanguage: "اللغة",
    assignColAssigned: "تاريخ التعيين",
    assignColDue: "الاستحقاق",
    assignColEmail: "بريد التعيين",
    assignColReminder: "آخر تذكير",
    assignColStatus: "الحالة",
    assignmentEmailSent: "أُرسل",
    assignmentEmailNotSent: "لم يُرسل",
    resendAssignmentEmail: "إعادة إرسال بريد التعيين",
    assignmentEmailResent: "تمت جدولة إعادة إرسال بريد التعيين",
    overdue: "متأخر",
    reminderStatus7d: "قبل 7 أيام",
    reminderStatus3d: "قبل 3 أيام",
    reminderStatusDue: "تذكير يوم الاستحقاق",
    assignColEdition: "الدورة",
    assignColKeywords: "الكلمات المفتاحية",
    assignColPaperStatus: "حالة الورقة",
    viewSubmittedReview: "عرض المراجعة",
    viewReviewTitle: "المراجعة المقدَّمة",
    viewReviewLead: "اطّلع على توصية المراجع وتعليقاته. قرار القبول/الرفض النهائي ليس جزءاً من هذه الخطوة.",
    submittedReview: "ملاحظات المراجع",
    noSubmittedReview: "لا توجد مراجعة مقدَّمة بعد.",
    reopenReview: "إعادة الفتح للتعديل",
    reviewReopened: "أُعيد فتح المراجعة للمراجع",
    reviewDecision: "المراجعة والقرار",
    reviewDecisionTitle: "المراجعة والقرار التحريري",
    reviewDecisionLead: "توصيات المراجعين استشارية فقط. المسؤول وحده يسجّل القرار النهائي للمؤلف.",
    reviewerFeedback: "المراجعون المعيَّنون",
    pendingReviewsCount: "{completed} مقدَّمة · {pending} معلّقة",
    noReviewersAssigned: "لا يوجد مراجعون معيَّنون لهذه الورقة بعد.",
    reviewPending: "معلّق",
    recordDecision: "تسجيل القرار التحريري",
    decisionAdvisory: "يُرسل هذا القرار بالبريد إلى المؤلف. لا تُعرض أسماء المراجعين أو تعليقاتهم إلا إذا أدرجتها في الرسالة.",
    decisionLabel: "القرار",
    decisionPlaceholder: "اختر قراراً",
    decisionAccept: "مقبولة",
    decisionMinor: "تعديل طفيف",
    decisionMajor: "تعديل جوهري",
    decisionReject: "مرفوضة",
    decisionMessage: "رسالة إلى المؤلف",
    decisionMessageHelp: "تظهر للمؤلف وتُدرج في بريد القرار.",
    forceUpdateDecision: "تأكيد تحديث القرار السابق (يُحفظ السجل)",
    saveDecision: "حفظ القرار",
    updateDecision: "تحديث القرار",
    decisionSaved: "تم حفظ القرار",
    decisionNeedChoice: "اختر قراراً قبل الحفظ.",
    currentDecision: "القرار الحالي",
    decidedAt: "تاريخ القرار",
    decisionHistory: "سجل القرارات",
    decisionUpdate: "تحديث",
    manuscriptRevisions: "مراجعات المخطوط",
    manuscriptRevisionsHelp:
      "يُحفظ السجل كاملاً. يحصل المراجعون دائمًا على أحدث مخطوط؛ تبقى الإصدارات السابقة متاحة للإدارة فقط.",
    currentRevision: "المراجعة الحالية",
    revisionNumber: "المراجعة {n}",
    revisionLatest: "الأحدث",
    downloadRevision: "تنزيل هذه المراجعة",
    generalCardsTitle: "بطاقات المشاركة العامة (الفئة A)",
    generalCardsHelp:
      "بطاقات عامة للمستمعين غير المسجّلين. بلا اسم أو صورة أو رمز QR. المعاينة تحافظ على نسبة أبعاد الشارة الحقيقية؛ وصفحات PDF بحجم الشارة الفعلي.",
    generalCardsCopies: "النسخ",
    previewGeneralCard: "معاينة البطاقة العامة",
    downloadGeneralCards: "تنزيل / طباعة جماعية",
    cardSettingsHelp:
      "العناوين ومسار الشعار والحجم الفعلي (card_width_mm / card_height_mm / card_safe_margin_mm). الشعار: daarunaim/crest.png. الإعداد المؤقت: 80 × 120 مم بهامش آمن 5 مم.",
    cardPrintHelp:
      "اطبع ملفات PDF بالحجم الفعلي / 100٪ (دون ملاءمة الصفحة). صور PNG بدقة 300 نقطة/بوصة من نفس التخطيط.",
    closePreview: "إغلاق المعاينة",
    badgePreviewTitle: "معاينة الشارة",
    hotelTitle: "حجز الفندق",
    hotelLead:
      "أنشئ وأرسل تفاصيل حجز الفندق إلى هذا المشارك المسجّل فقط. المستلم ثابت على بريد التسجيل.",
    hotelRecipient: "المستلم (ثابت)",
    hotelRecipientFixed: "يُرسل هذا البريد دائمًا إلى المشارك المحدد — لا يمكن تغيير المستلم هنا.",
    hotelCode: "رمز التسجيل",
    hotelLanguage: "اللغة المفضلة",
    hotelStatus: "حالة الحجز",
    hotelLastSent: "آخر إرسال",
    hotelName: "اسم الفندق",
    hotelAddress: "عنوان / موقع الفندق",
    hotelCheckIn: "تاريخ الوصول",
    hotelCheckOut: "تاريخ المغادرة",
    hotelBookingRef: "مرجع الحجز",
    hotelRoomType: "نوع الغرفة",
    hotelRoomNumber: "رقم الغرفة",
    hotelRoomNumberHelp: "يظهر بوضوح على بطاقة دخول الفندق",
    hotelContactPhone: "هاتف الاتصال",
    hotelMapsUrl: "رابط خرائط Google / الموقع (اختياري)",
    hotelNotes: "ملاحظات / تعليمات",
    hotelSave: "حفظ المسودة",
    hotelSaved: "تم حفظ حجز الفندق",
    hotelPreview: "معاينة البريد",
    hotelSend: "إرسال بريد الحجز",
    hotelResend: "إعادة الإرسال / التحديث",
    hotelSent: "تم إرسال بريد حجز الفندق",
    hotelTo: "إلى",
    hotelHistory: "سجل التسليم",
    markLive: "تعيين كبث مباشر",
    markEnded: "تعيين كمنتهية",
    downloadBadge: "تنزيل البطاقة",
    checkIn: "تسجيل الحضور",
    resend: "إعادة إرسال بريد التسجيل",
    changeStatus: "تحديث الحالة",
    save: "حفظ الإعدادات",

    messages: "الرسائل",
    messagesLead:
      "أرسل بريداً مباشراً إلى أي عنوان صالح. لا يُنشئ هذا مستخدماً أو تسجيلاً أو سجل مُحكّم.",
    msgCompose: "إنشاء رسالة",
    msgComposeHelp:
      "يُرسل الموضوع والنص كما كتبتهما داخل قالب المجمع الأخضر.",
    msgRecipientEmail: "بريد المستلم",
    msgSubject: "الموضوع",
    msgBody: "نص الرسالة",
    msgSend: "إرسال البريد",
    msgSending: "جاري الإرسال…",
    msgSent: "تم إرسال البريد بنجاح.",
    msgNeedEmail: "بريد المستلم مطلوب.",
    msgNeedSubject: "الموضوع مطلوب.",
    msgNeedBody: "نص الرسالة مطلوب.",
    msgInvalidEmail: "أدخل عنوان بريد صالحاً.",
    msgHistory: "الرسائل الأخيرة",
    msgHistoryLead: "سجل التسليم من دفتر بريد المؤتمر.",
    msgHistoryEmpty: "لا رسائل مرسلة بعد.",
    msgColRecipient: "المستلم",
    msgColSubject: "الموضوع",
    msgColSentAt: "أُرسل",

    correspondence: "المراسلات / الرسائل",
    correspondenceLead:
      "حرّر خطاب المجمع الرسمي قسمًا بقسم. اختيار المستلمين للتسليم فقط — لا يُنشأ نص الخطاب تلقائيًا من الاسم المحدد.",
    corrHistory: "سجل المراسلات",
    corrHistoryLead: "ابحث عن الرسائل السابقة وأعد تنزيل PDF أو أعد الإرسال.",
    corrSearchRecipients: "البحث عن المستلمين",
    corrSearchPlaceholder: "الاسم أو البريد أو النوع…",
    corrNoRecipients: "لا مستلمين مطابقين (المشرفون مستبعدون).",
    corrNeedRecipients: "اختر مستلمًا واحدًا على الأقل.",
    corrNeedTitle: "أدخل الموضوع.",
    corrNeedBody: "أدخل نص الرسالة.",
    corrNeedAddressee: "أدخل عنوان المستلم / المُخاطَب.",
    corrPlainSectionInvalid: "يُسمح بالحروف والأرقام والمسافات والفواصل والنقاط فقط (بدون رموز مثل / أو -).",
    corrFixRequired: "يرجى إكمال الحقول المطلوبة قبل المتابعة.",
    corrRequired: "مطلوب",
    corrRecipientsHeading: "المستلمون",
    corrComposeHeading: "أقسام الخطاب",
    corrComposeHint:
      "الحقول بترتيب ظهورها في الخطاب. الحقول المطلوبة مُعلَّمة بنجمة حمراء.",
    corrSelectedNone: "لم يُحدد أحد",
    corrSelectedCount: "{count} محددون",
    corrSelect: "تحديد",
    corrRemoveRecipient: "إزالة المستلم",
    corrRecipient: "المستلم",
    corrType: "النوع",
    corrTypeParticipant: "مشارك",
    corrTypeRegisteredReviewer: "مراجع مسجل",
    corrTypeExternalReviewer: "مراجع خارجي",
    corrExternalHeading: "مستلمون غير مسجلين",
    corrExternalHelp:
      "أضف أي بريد صالح لإرسال الخطاب الموقّع نفسه — دون إنشاء حساب أو تسجيل.",
    corrExternalEmail: "بريد خارجي",
    corrExternalName: "الاسم الظاهر (اختياري)",
    corrExternalNamePlaceholder: "الاسم في تحية البريد",
    corrExternalAdd: "إضافة البريد",
    corrTypeExternal: "غير مسجل",
    corrAddressee: "عنوان المستلم / المُخاطَب",
    corrAddresseePlaceholder: "مثال: فضيلة الشيخ الدكتور عبد الرحيم العطري",
    corrPrayerHonorific: "دعاء / تكريم",
    corrPrayerHonorificPlaceholder: "مثال: يحفظكم الله ويرعاكم",
    corrLocation: "الموقع / الجهة / البلد",
    corrLocationPlaceholder: "مثال: المملكة المغربية",
    corrGreeting: "التحية / السلام",
    corrGreetingPlaceholder: "مثال: السلام عليكم ورحمة الله وبركاته",
    corrTitle: "الموضوع",
    corrTitlePlaceholder: "نص الموضوع (تُضاف كلمة الموضوع: تلقائيًا)",
    corrBody: "نص الرسالة",
    corrRteBold: "عريض",
    corrRteItalic: "مائل",
    corrRteUnderline: "تسطير",
    corrRteAlignLeft: "محاذاة لليسار",
    corrRteAlignCenter: "توسيط",
    corrRteAlignRight: "محاذاة لليمين",
    corrRteAlignJustify: "ضبط",
    corrRteBulletList: "قائمة نقطية",
    corrRteOrderedList: "قائمة مرقمة",
    corrRteUndo: "تراجع",
    corrRteRedo: "إعادة",
    corrRteFontSize: "حجم الخط",
    corrClosing: "الخاتمة",
    corrClosingPlaceholder: "مثال: والسلام عليكم ورحمة الله وبركاته",
    corrDate: "تاريخ الرسالة",
    corrPreviewPdf: "معاينة PDF",
    corrPreviewing: "جارٍ تجهيز المعاينة…",
    corrSend: "إرسال",
    corrSending: "جارٍ الإرسال…",
    corrPreviewReady: "فُتحت معاينة PDF في تبويب جديد.",
    corrSendSuccessOne: "تم إرسال الرسالة بنجاح إلى {name}.",
    corrSendSuccessMany: "تم إرسال الرسالة بنجاح إلى {count} مستلمين.",
    corrSendPartial:
      "إرسال جزئي: نجح {sent} وفشل {failed}. افتح سجل المراسلات للمراجعة وإعادة الإرسال.",
    corrSendAllFailed: "فشل الإرسال لجميع المستلمين ({failed}). افتح سجل المراسلات للمراجعة.",
    corrNoticeSuccess: "نجاح",
    corrNoticeError: "خطأ",
    corrViewHistory: "فتح سجل المراسلات",
    corrSearchHistory: "بحث بالمستلم أو العنوان",
    corrDateFrom: "من",
    corrDateTo: "إلى",
    corrFilter: "تصفية",
    corrCreated: "تاريخ الإنشاء",
    corrDownload: "تنزيل PDF",
    corrResend: "إعادة الإرسال",
    corrResendDone: "أُعيد إرسال الرسالة",
    corrHistoryEmpty: "لا مراسلات بعد.",
    corrStatusAll: "كل الحالات",
    corrStatusGenerated: "مُنشأ",
    corrStatusSent: "مُرسل",
    corrStatusFailed: "فشل",

    certificates: "الشهادات",
    certificatesLead:
      "إصدار شهادات المشاركة للمشاركين والمراجعين المسجلين. لا يمكن اختيار المشرفين كمستلمين.",
    certHistory: "سجل الشهادات",
    certHistoryLead: "ابحث عن الشهادات السابقة وأعد تنزيل PDF أو أعد الإرسال.",
    certSearchRecipients: "البحث عن المستلمين",
    certSearchPlaceholder: "الاسم أو البريد أو النوع…",
    certNoRecipients: "لا مستلمين مطابقين (المشرفون مستبعدون).",
    certNeedRecipients: "اختر مستلمًا واحدًا على الأقل.",
    certFixRequired: "يرجى اختيار مستلم واحد على الأقل قبل المتابعة.",
    certRequired: "مطلوب",
    certRecipientsHeading: "المستلمون",
    certOptionsHeading: "الخيارات",
    certSelectedNone: "لم يُحدد أحد",
    certSelectedCount: "{count} محددون",
    certSelect: "تحديد",
    certRemoveRecipient: "إزالة المستلم",
    certRecipient: "المستلم",
    certType: "النوع",
    certLanguage: "اللغة",
    certLanguageAuto: "تلقائي (تفضيل المستلم)",
    certLanguageEn: "الإنجليزية",
    certLanguageAr: "العربية",
    certLanguageFr: "الفرنسية",
    certLanguageAll: "كل اللغات",
    certNotes: "ملاحظات (اختياري)",
    certPersonalize: "تخصيص لكل مستلم",
    certPersonalizeLead:
      "عيّن اللقب والاسم ورسالة تقدير اختيارية لكل مستلم. يُملأ اللقب مسبقًا من التسجيل إن وُجد.",
    certHonorific: "اللقب / التكريم",
    certHonorificNone: "بدون",
    certHonorificSheikh: "Sheikh",
    certHonorificDr: "Dr.",
    certHonorificSheikhDr: "Sheikh Dr.",
    certHonorificMr: "Mr.",
    certHonorificSheikhAr: "الشيخ",
    certHonorificDrAr: "الدكتور",
    certHonorificSheikhDrAr: "الشيخ الدكتور",
    certHonorificCustom: "مخصص…",
    certHonorificCustomValue: "لقب مخصص",
    certRecipientName: "اسم المستلم على الشهادة",
    certAppreciation: "رسالة تقدير / نص إضافي (اختياري)",
    certAppreciationPlaceholder: "سطر قصير يظهر تحت الاسم…",
    certPreviewThisRecipient: "استخدم للمعاينة",
    certPreviewPdf: "معاينة PDF",
    certPreviewing: "جارٍ تجهيز المعاينة…",
    certSend: "إرسال",
    certSending: "جارٍ الإرسال…",
    certPreviewReady: "فُتحت معاينة PDF في تبويب جديد.",
    certSendSuccessOne: "تم إرسال الشهادة بنجاح إلى {name}.",
    certSendSuccessMany: "تم إرسال الشهادة بنجاح إلى {count} مستلمين.",
    certSendPartial:
      "إرسال جزئي: نجح {sent} وفشل {failed}. افتح سجل الشهادات للمراجعة وإعادة الإرسال.",
    certSendAllFailed: "فشل الإرسال لجميع المستلمين ({failed}). افتح سجل الشهادات للمراجعة.",
    certNoticeSuccess: "نجاح",
    certNoticeError: "خطأ",
    certViewHistory: "فتح سجل الشهادات",
    certSearchHistory: "بحث بالمستلم أو الملاحظات",
    certDateFrom: "من",
    certDateTo: "إلى",
    certFilter: "تصفية",
    certCreated: "تاريخ الإنشاء",
    certDownload: "تنزيل PDF",
    certResend: "إعادة الإرسال",
    certResendDone: "أُعيد إرسال الشهادة",
    certHistoryEmpty: "لا شهادات بعد.",
    certStatusAll: "كل الحالات",
    certStatusGenerated: "مُنشأ",
    certStatusSent: "مُرسل",
    certStatusFailed: "فشل",

    saved: "تم الحفظ",
    search: "بحث…",
    filterAll: "الكل",
    colTitle: "العنوان",
    colAuthor: "المؤلف",
    colLanguage: "اللغة",
    colSubmitted: "تاريخ التقديم",
    colStatus: "الحالة",
    colFile: "الملف",
    colWorkflow: "سير العمل",
    preparePublish: "تجهيز ونشر",
    editPublication: "تعديل النشر",
    publishTitle: "نشر الورقة",
    publishLead:
      "أثْر الورقة المقبولة ببيانات النشر وشعار المؤتمر، عاين ملف PDF، ثم انشرها في أرشيف الأوراق العامة. يبقى ملف Word الخاص بالمؤلف خاصًا.",
    publishNeedAccept: "اقبل الورقة أولًا (الحالة = مقبولة) قبل النشر.",
    publishSuccess: "نُشرت في أرشيف الأوراق العامة.",
    currentStatus: "الحالة الحالية",
    publicYes: "أرشيف عام",
    viewPdf: "عرض PDF",
    manuscript: "مخطوط المؤلف",
    downloadWord: "تنزيل مخطوط Word",
    viewPublicPdf: "عرض PDF العام",
    fieldTitle: "العنوان",
    fieldTitleAlt: "عنوان بديل",
    fieldAuthors: "المؤلفون",
    fieldAffiliation: "الانتماء/الانتماءات",
    fieldAbstract: "الملخص",
    fieldKeywords: "الكلمات المفتاحية",
    fieldAcknowledgements: "الشكر والتقدير",
    fieldLicense: "الترخيص",
    includeLogo: "إدراج شعار مؤتمر دار النعيم على غلاف PDF",
    uploadCameraReady: "رفع PDF جاهز للطباعة (اختياري)",
    uploadCameraReadyHelp:
      "إن وُجد يُنشر كما هو. وإلا يُنشئ النظام PDFًا بعلامة المؤتمر من الحقول أعلاه.",
    previewPdf: "معاينة PDF",
    publishNow: "نشر إلى الأرشيف",
  },
  common: {
    loading: "جارٍ التحميل…",
    error: "حدث خطأ",
    back: "رجوع",
    view: "عرض",
    download: "تنزيل",
    print: "طباعة",
    close: "إغلاق",
    cancel: "إلغاء",
    save: "حفظ",
    edit: "تحرير",
    delete: "حذف",
    mainNav: "القائمة الرئيسية",
    poweredBy: "مدعوم من",
    copyrightFingletek: "© Fingletek",
    fingletekPhone: "+358 44 0685538",
    skipToContent: "تخطَّ إلى المحتوى",
    openMenu: "فتح القائمة",
    closeMenu: "إغلاق القائمة",
    pageOf: "صفحة {page} من {pages}",
    previousPage: "السابق",
    nextPage: "التالي",
    rowsPerPage: "صفوف في الصفحة",
    showingCount: "عرض {from}–{to} من {total}",
  },
};
